<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-purple-50 to-pink-100 animate-gradient-x">
    <div v-loading="loading"
         class="bg-white/90 backdrop-blur-sm p-10 rounded-2xl shadow-2xl w-full max-w-md transform transition-all duration-300 hover:scale-105 hover:shadow-indigo-200">
      <!-- 左上角标志 -->
      <div class="mb-10 text-center transform transition-all duration-500 hover:scale-110">
        <img @click="tohome" alt="IP奇迹ip Logo" class="h-24 mx-auto cursor-pointer" src="@/assets/logB.png"/>
      </div>
      <!-- 密码登录标题 -->
      <h2 class="text-4xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-indigo-600 mb-10 text-center">
        欢迎登录
      </h2>
      <!-- 邮箱输入框 -->
      <div class="mb-6">
        <div class="relative group">
          <i class="fas fa-envelope absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-hover:text-indigo-500 transition-colors duration-200">
          </i>
          <input
              class="w-full pl-12 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all duration-200 bg-white/50 backdrop-blur-sm"
              type="email"
              :maxlength="100"
              v-model.trim="form.email"
              placeholder="请输入邮箱"/>
        </div>
      </div>
      <!-- 密码输入框 -->
      <div class="mb-6">
        <div class="relative group">
          <i class="fas fa-lock absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-hover:text-indigo-500 transition-colors duration-200">
          </i>
          <input
              class="w-full pl-12 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all duration-200 bg-white/50 backdrop-blur-sm"
              type="password"
              :maxlength="50"
              v-model.trim="form.pass"
              placeholder="请输入密码"/>
        </div>
      </div>
      <!-- 复选框 -->
      <div class="mb-8 flex items-center justify-between">
        <div class="flex items-center group cursor-pointer">
          <input
              class="mr-3 w-5 h-5 text-indigo-600 border-2 border-gray-300 rounded-md focus:ring-indigo-500 focus:ring-offset-0 transition-all duration-200 cursor-pointer"
              type="checkbox"
              v-model="checked"
              id="agreeTerms"/>
          <label class="text-sm text-gray-600 group-hover:text-indigo-600 transition-colors duration-200 select-none cursor-pointer" for="agreeTerms">
            我已阅读并同意
            <a class="text-indigo-600 hover:text-indigo-800 font-medium border-b border-indigo-600 hover:border-indigo-800" href="javascript:void(0);">
              服务条款
            </a>
          </label>
        </div>
      </div>
      <!-- 登录按钮 -->
      <button
          class="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-4 px-6 rounded-xl hover:from-indigo-700 hover:to-purple-700 focus:outline-none focus:ring-4 focus:ring-indigo-300 shadow-lg transform transition-all duration-300 hover:scale-102 hover:shadow-indigo-200 font-semibold text-lg"
          @click="codeLogin('form')">
        <i class="fas fa-sign-in-alt mr-3 animate-pulse">
        </i>
        登录
      </button>
      <!-- 注册链接 -->
      <div class="mt-10 text-center">
        <span class="text-gray-500">
         还没有账号？
        </span>
        <a class="text-indigo-600 hover:text-indigo-800 font-medium ml-2 border-b border-indigo-600 hover:border-indigo-800 transition-colors duration-200"
           @click="touserlogin">
          立即注册
        </a>
      </div>
    </div>

  </div>
</template>

<script>
import api from "@/requset/api";

export default {
  name: 'LoginPage',
  data() {
    return {
      loading: false,
      checked: "",
      mima_show: true,
      yanzma_show: false,
      radio: "1",
      datauser: {
        name: "",
        smsCode: "",
      },
      huakuai: "",
      show: true,
      count: 60,
      form: {
        email: "",
        username: "",
        pass: "",
      },
      formyzm: {
        mobile: "",
        captcha: "",
        checkMove: "",
      },
      codeRules: {
        username: [{required: true, message: "请输入用户名", trigger: "blur"}],
        email: [{required: true, message: "请输入邮箱", trigger: "blur"}],
        phoneB: [{required: true, message: "请输入手机号", trigger: "blur"}],
        pass: [{required: true, message: "请输入密码", trigger: "blur"}],
      },
    };
  },
  components: {},
  directives: {
    move(el, binding) {
      el.onmousedown = function (e) {
        var X = e.clientX - el.offsetLeft;
        document.onmousemove = function (e) {
          var endx = e.clientX - X;
          el.className = "move moveBefore";
          el.style.left = endx + "px";
          var width =
              document.querySelector(".movebox").offsetWidth -
              document.querySelector(".move").offsetWidth;
          el.parentNode.children[0].style.width = endx + "px";
          el.parentNode.children[1].innerHTML = "按住滑块,拖动到最右边";

          //临界值小于
          if (endx <= 0) {
            el.style.left = 0 + "px";
            el.parentNode.children[0].style.width = 0 + "px";
          }

          //临界值大于
          if (parseInt(el.style.left) >= width) {
            el.style.left = width + "px";
            el.parentNode.children[0].style.width = width + "px";
            el.parentNode.children[1].innerHTML =
                "<span style='color:#000'>验证通过</span>";
            el.className = "move moveSuccess";
            document.onmousemove = null;
            el.onmousedown = null;

            binding.value();
          }
        };
      };
      document.onmouseup = function () {
        document.onmousemove = null;
      };
    },
  },

  mounted() {
  },
  methods: {
    qiehuan(name) {
      if (name == "密码登录") {
        this.mima_show = true;
        this.yanzma_show = false;
      } else if (name == "验证码登录") {
        this.mima_show = false;
        this.yanzma_show = true;
      }
    },
    pull() {
      this.formyzm.checkMove = true;
    },
    //发送短信验证码
    sendCode() {
      if (!this.formyzm.mobile) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return;
      }
      if (!this.formyzm.checkMove) {
        this.$message({
          message: "滑块验证有误，请重新验证",
          type: "warning",
        });
        return;
      }

      api.send_captcha({
        mobile: this.formyzm.mobile,
      })
        .then((res) => {
          console.log(res.data.error_code);
          if (res.data.error_code === 0) {
            this.$message({
              message: "验证码已发送",
            });

            this.show = false;
            let timeId = setInterval(() => {
              if (this.count <= 0) {
                this.show = true;
                clearInterval(timeId);
                this.count = 60;
              } else {
                this.count--;
              }
            }, 1000);
          } else {
            this.$message({
              message: res.data.message,
              type: "warning",
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "发送验证码失败，请稍后重试",
            type: "error",
          });
        });
    },
    tohome() {
      this.$router.push({path: "/"});
    },

    codeLoginyzm() {
      if (this.checked) {
        api
            .login_by_captcha({
              mobile: this.formyzm.mobile,
              captcha: this.formyzm.captcha,
            })
            .then((res) => {
              console.log(res.data);
              if (res.data.error_code == 0) {
                this.$cookies.set("userdata", res.data);
                this.$router.push({
                  path: "getapi", query: {name: "api提取"}
                });
              } else {
                this.$message({
                  message: res.data.message,
                  type: "warning"
                });
              }
            })
            .catch((err) => {
              console.log(err, "走失败");
            });
      } else {
        this.$message({
          message: "请勾选《用户协议》",
          type: "warning",
        });
      }
    },

    codeLogin() {
      if (this.checked) {
        this.loading = true
        api.loginIn({
          email: this.form.email,
          password: this.form.pass,
        })
            .finally(() => {
              this.loading = false
            })
            .then((res) => {
              console.log(res.data);
              if (res.data.error_code == 0) {
                this.$cookies.set("userdata", res.data);
                // this.$router.push({path: "ucenter", query: {asidename: 'order_list'}});
                this.$router.push({path: "ucenter", query: {asidename: 'jbxx'}});
              } else {
                this.$message({
                  message: res.data.message,
                  type: "warning"
                });
              }
            })
            .catch((err) => {
              console.log(err, "走失败");
            });
      } else {
        this.$message({
          message: "请勾选《用户协议》",
          type: "warning",
        });
      }
    },
    touserlogin() {
      this.$router.push({path: "userlogin"});
    },
  },
};
</script>
